/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationCatalogEntity } from './IntegrationCatalogEntity';
import {
    IntegrationCatalogEntityFromJSON,
    IntegrationCatalogEntityFromJSONTyped,
    IntegrationCatalogEntityToJSON,
    IntegrationCatalogEntityToJSONTyped,
} from './IntegrationCatalogEntity';

/**
 * Review entity
 * @export
 * @interface IntegrationReviewEntity
 */
export interface IntegrationReviewEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    id?: string;
    /**
     * 
     * @type {IntegrationCatalogEntity}
     * @memberof IntegrationReviewEntity
     */
    integration?: IntegrationCatalogEntity;
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    userId?: string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationReviewEntity
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    reviewText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationReviewEntity
     */
    isVerifiedPurchase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationReviewEntity
     */
    isModerated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationReviewEntity
     */
    isApproved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationReviewEntity
     */
    moderatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationReviewEntity
     */
    moderatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof IntegrationReviewEntity
     */
    helpfulCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationReviewEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationReviewEntity
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the IntegrationReviewEntity interface.
 */
export function instanceOfIntegrationReviewEntity(value: object): value is IntegrationReviewEntity {
    return true;
}

export function IntegrationReviewEntityFromJSON(json: any): IntegrationReviewEntity {
    return IntegrationReviewEntityFromJSONTyped(json, false);
}

export function IntegrationReviewEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationReviewEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'integration': json['integration'] == null ? undefined : IntegrationCatalogEntityFromJSON(json['integration']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'title': json['title'] == null ? undefined : json['title'],
        'reviewText': json['reviewText'] == null ? undefined : json['reviewText'],
        'isVerifiedPurchase': json['isVerifiedPurchase'] == null ? undefined : json['isVerifiedPurchase'],
        'isModerated': json['isModerated'] == null ? undefined : json['isModerated'],
        'isApproved': json['isApproved'] == null ? undefined : json['isApproved'],
        'moderatedBy': json['moderatedBy'] == null ? undefined : json['moderatedBy'],
        'moderatedAt': json['moderatedAt'] == null ? undefined : (new Date(json['moderatedAt'])),
        'helpfulCount': json['helpfulCount'] == null ? undefined : json['helpfulCount'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function IntegrationReviewEntityToJSON(json: any): IntegrationReviewEntity {
    return IntegrationReviewEntityToJSONTyped(json, false);
}

export function IntegrationReviewEntityToJSONTyped(value?: IntegrationReviewEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'integration': IntegrationCatalogEntityToJSON(value['integration']),
        'tenantId': value['tenantId'],
        'userId': value['userId'],
        'rating': value['rating'],
        'title': value['title'],
        'reviewText': value['reviewText'],
        'isVerifiedPurchase': value['isVerifiedPurchase'],
        'isModerated': value['isModerated'],
        'isApproved': value['isApproved'],
        'moderatedBy': value['moderatedBy'],
        'moderatedAt': value['moderatedAt'] == null ? undefined : ((value['moderatedAt']).toISOString()),
        'helpfulCount': value['helpfulCount'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

